import React from "react";

interface MessageIndicatorCountProps {
    icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
    label: string;
    count: number;
}

export const MessageIndicatorCount: React.FC<MessageIndicatorCountProps> = ({
    icon: Icon,
    label,
    count,
}) => (
    <span className="inline-flex items-center gap-0.5" title={label}>
        <Icon className="h-3.5 w-3.5 text-gray-400" aria-hidden="true" />
        <span className="sr-only">{label}</span>
        {count}
    </span>
);
